module.exports = __webpack_public_path__ + "static/media/da-home-5.517791e9.jpg";